var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ui-frame", [
    _c("div", [
      _c("h1", [_vm._v(_vm._s(_vm.$t("Omnichannel.Status.Title")))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("Omnichannel.Status.Description")))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }